exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".account-component .card-verify {\n  -webkit-transition: all 0.2s ease !important;\n}", ""]);

// exports
